import { render, staticRenderFns } from "./akw.vue?vue&type=template&id=77dd2976&scoped=true&"
import script from "./akw.vue?vue&type=script&lang=js&"
export * from "./akw.vue?vue&type=script&lang=js&"
import style0 from "./akw.vue?vue&type=style&index=0&id=77dd2976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd2976",
  null
  
)

export default component.exports